import React, {Component} from 'react';
import Alert from './Alert';
import './AlertWrapper.scss';

export default class AlertWrapper extends Component {
  render() {
    const {alerts} = this.props;
    return (
      <div className="alert-wrapper">
        {
          alerts.map((alert, i) => {
            return <Alert key={i} index={i} {...alert} {...this.props}/>
          })
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./client/components/AlertWrapper.jsx